// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"22238ca9","455":"e105745b","885":"9a0e1f64"}[chunkId] + ".chunk.js";
};